import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard2');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard2',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard2/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.d2-shell {
  --d2-ink: #162236;
  --d2-text: #556379;
  --d2-muted: #7d8a9c;
  --d2-line: #dce3ec;
  --d2-line-soft: #e9edf3;
  --d2-canvas: #f5f7fa;
  --d2-surface: #ffffff;
  --d2-blue: #125fc2;
  --d2-blue-soft: #eaf3ff;
  --d2-green: #237454;
  --d2-green-soft: #eaf7f1;
  --d2-amber: #8a631f;
  --d2-amber-soft: #fff5df;
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  background: var(--d2-surface);
  color: var(--d2-ink);
  font-family: Inter, "Pretendard Variable", Pretendard, "Noto Sans KR", sans-serif;
}

button,
input {
  font: inherit;
}

button {
  cursor: pointer;
}

.d2-notice {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  margin: 16px 24px;
  border: 1px solid #cfdceb;
  border-left: 3px solid var(--d2-blue);
  background: #f7faff;
  padding: 11px 14px;
  color: var(--d2-blue);
}

.d2-notice strong,
.d2-notice p {
  margin: 0;
}

.d2-notice strong {
  color: var(--d2-ink);
  font-size: 13px;
}

.d2-notice p {
  margin-top: 2px;
  color: var(--d2-text);
  font-size: 12px;
}

.d2-notice button {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  gap: 6px;
  border: 1px solid #c8d6e7;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 11px;
  color: var(--d2-blue);
  font-size: 12px;
  font-weight: 700;
}

.d2-hero {
  position: relative;
  display: flex;
  min-height: 372px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(90deg, rgba(4, 16, 35, 0.84) 0%, rgba(5, 22, 48, 0.8) 52%, rgba(8, 35, 54, 0.68) 100%), url("/assets/dashboard/agent-data-hero.png") center 58%/cover no-repeat;
  padding: 48px 24px;
  color: #ffffff;
  text-align: center;
}

.d2-hero::before {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(8, 24, 45, 0.04), rgba(2, 13, 28, 0.44));
  content: "";
}

.d2-hero-copy {
  position: relative;
  z-index: 1;
  display: flex;
  width: min(820px, 100%);
  min-width: 0;
  flex-direction: column;
  align-items: center;
}

.d2-hero-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #9bc8f4;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.d2-hero-status span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #48b38c;
  box-shadow: 0 0 0 4px rgba(72, 179, 140, 0.14);
}

.d2-hero h1,
.d2-hero-copy > p {
  margin: 0;
}

.d2-hero h1 {
  max-width: 760px;
  font-size: 38px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.24;
}

.d2-hero-copy > p {
  max-width: 760px;
  margin-top: 14px;
  color: #d7e2ee;
  font-size: 15px;
  line-height: 1.65;
}

.d2-ai-search {
  display: flex;
  width: min(760px, 100%);
  min-height: 60px;
  box-sizing: border-box;
  align-items: center;
  gap: 12px;
  margin-top: 28px;
  border: 1px solid rgba(255, 255, 255, 0.52);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.97);
  padding: 7px 7px 7px 18px;
  box-shadow: 0 16px 38px rgba(1, 11, 29, 0.22);
  color: var(--d2-blue);
  text-align: left;
}

.d2-ai-search > i {
  flex: none;
  color: var(--d2-blue);
  font-size: 16px;
}

.d2-ai-search input {
  width: 100%;
  height: 44px;
  min-width: 0;
  flex: 1;
  appearance: none;
  border: 0 !important;
  outline: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 4px !important;
  color: #162236 !important;
  font-size: 14px;
}

.d2-ai-search input::placeholder {
  color: #8793a6 !important;
}

.d2-ai-search input::-webkit-search-cancel-button {
  display: none;
}

.d2-ai-search button {
  display: inline-flex;
  min-height: 44px;
  flex: none;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  border-radius: 8px;
  background: var(--d2-blue);
  padding: 0 18px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 800;
}

.d2-ai-search button:hover:not(:disabled) {
  background: #0d55ad;
}

.d2-ai-search button:disabled {
  cursor: default;
  opacity: 0.45;
}

.d2-metrics {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;
  margin: 0;
  background: #f3f7fc;
  padding-block: 42px;
  padding-inline: max(24px, (100% - 1200px) / 2 + 24px);
}

.d2-metrics article {
  display: flex;
  min-width: 0;
  min-height: 144px;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #e7edf5;
  border-radius: 8px;
  background: var(--d2-surface);
  padding: 20px 14px;
  box-shadow: 0 10px 24px rgba(32, 72, 119, 0.08);
  text-align: center;
}

.d2-metrics p,
.d2-metrics strong,
.d2-metrics em,
.d2-metrics small {
  margin: 0;
  font-style: normal;
}

.d2-metrics p {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #3d4c62;
  font-size: 14px;
  font-weight: 800;
}

.d2-metrics p i {
  color: #9ba8b9;
  font-size: 12px;
}

.d2-metric-value {
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-top: 16px;
}

.d2-metrics strong {
  color: var(--d2-blue);
  font-size: 36px;
  font-weight: 820;
  letter-spacing: 0;
  line-height: 1;
}

.d2-metrics em {
  margin-left: 5px;
  color: #718096;
  font-size: 13px;
  font-weight: 700;
}

.d2-metrics small {
  display: block;
  max-width: 100%;
  margin-top: 12px;
  overflow: hidden;
  color: var(--d2-muted);
  font-size: 12px;
  line-height: 1.4;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.d2-quick-menu {
  position: fixed;
  top: 50%;
  right: 56px;
  z-index: 30;
  display: flex;
  width: 96px;
  box-sizing: border-box;
  flex-direction: column;
  overflow: hidden;
  transform: translateY(-50%);
  border: 1px solid #e1e7ef;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.97);
  padding: 8px;
  box-shadow: 0 12px 34px rgba(11, 37, 70, 0.15);
  backdrop-filter: blur(10px);
}

.d2-quick-menu button {
  display: flex;
  min-height: 66px;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 0;
  border-bottom: 1px solid #edf1f6;
  background: transparent;
  padding: 4px 2px;
  color: #65758d;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.d2-quick-menu button:last-child {
  border-bottom: 0;
}

.d2-quick-menu button:hover,
.d2-quick-menu button:focus-visible {
  border-radius: 8px;
  outline: 0;
  background: #eef5fe;
  color: var(--d2-blue);
}

.d2-quick-menu-icon {
  display: inline-flex;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f0f4f8;
  color: #687a94;
}

.d2-quick-menu-icon i {
  color: inherit;
  font-size: 20px;
}

.d2-section {
  border: 1px solid var(--d2-line);
  border-radius: 8px;
  background: var(--d2-surface);
}

.d2-catalog {
  border: 0;
  border-radius: 0;
  padding-block: 34px 46px;
  padding-inline: max(24px, (100% - 1200px) / 2 + 24px);
}

.d2-catalog .d2-section-header {
  align-items: center;
  margin-bottom: 22px;
  border-bottom: 1px solid var(--d2-line-soft);
  padding: 0 6px 20px;
}

.d2-section-header {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  justify-items: center;
  gap: 8px;
  text-align: center;
}

.d2-section-header h2,
.d2-section-header span {
  margin: 0;
}

.d2-section-header h2 {
  color: var(--d2-ink);
  font-size: 26px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.35;
}

.d2-section-header > div > span {
  display: block;
  margin-top: 5px;
  color: #778397;
  font-size: 13px;
}

.d2-kicker {
  margin: 0 0 5px;
  color: var(--d2-blue);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0;
}

.d2-model-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin: 0 6px 22px;
}

.d2-model-summary article {
  display: grid;
  min-width: 0;
  grid-template-columns: 32px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  border: 1px solid var(--d2-line-soft);
  border-radius: 8px;
  background: #f8fafc;
  padding: 12px;
}

.d2-type-icon {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #eaf2fc;
  color: var(--d2-blue);
  font-size: 13px;
}

.d2-model-summary strong,
.d2-model-summary small,
.d2-model-summary b {
  display: block;
  min-width: 0;
  margin: 0;
}

.d2-model-summary strong {
  overflow: hidden;
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.d2-model-summary small {
  margin-top: 2px;
  overflow: hidden;
  color: var(--d2-muted);
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.d2-model-summary b {
  color: var(--d2-blue);
  font-size: 13px;
  white-space: nowrap;
}

.d2-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border: 1px solid var(--d2-line);
  border-bottom: 0;
  border-radius: 8px 8px 0 0;
  background: #f8fafc;
  padding: 14px 18px;
}

.d2-filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.d2-filter {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  gap: 6px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  padding: 0 10px;
  color: #657287;
  font-size: 12px;
  font-weight: 700;
}

.d2-filter small {
  color: #94a0b1;
  font-size: 12px;
}

.d2-filter:hover {
  background: #f0f5fb;
}

.d2-filter.is-active {
  border-color: #b7d0ee;
  background: #edf5ff;
  color: #135eac;
}

.d2-filter.is-active small {
  color: #376fa9;
}

.d2-search {
  display: flex;
  width: min(390px, 42%);
  min-width: 280px;
  height: 38px;
  box-sizing: border-box;
  align-items: center;
  gap: 9px;
  border: 1px solid var(--d2-line);
  border-radius: 8px;
  background: #ffffff;
  padding: 0 11px;
  color: #93a0b3;
}

.d2-search:focus-within {
  border-color: #7aa8dc;
  box-shadow: 0 0 0 2px rgba(36, 117, 203, 0.08);
}

.d2-search input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--d2-ink);
  font-size: 12px;
}

.d2-search input::placeholder {
  color: #9ca7b8;
}

.d2-search button {
  border: 0;
  background: transparent;
  padding: 2px;
  color: #8793a6;
}

.d2-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--d2-line);
  border-radius: 0 0 8px 8px;
  box-shadow: 0 12px 30px rgba(31, 61, 98, 0.06);
}

.d2-table {
  width: 100%;
  min-width: 1120px;
  border-collapse: collapse;
  table-layout: fixed;
}

.d2-table th,
.d2-table td {
  box-sizing: border-box;
  border-bottom: 1px solid var(--d2-line-soft);
  padding: 14px 16px;
  text-align: left;
  vertical-align: top;
}

.d2-table th {
  background: #f7f9fc;
  color: #667388;
  font-size: 12px;
  font-weight: 800;
}

.d2-table th:first-child,
.d2-table td:first-child {
  width: 23%;
  padding-left: 22px;
}

.d2-table th:nth-child(2),
.d2-table td:nth-child(2) {
  width: 13%;
}

.d2-table th:nth-child(3),
.d2-table td:nth-child(3) {
  width: 23%;
}

.d2-table th:nth-child(4),
.d2-table td:nth-child(4) {
  width: 18%;
}

.d2-table th:nth-child(5),
.d2-table td:nth-child(5) {
  width: 12%;
}

.d2-table th:last-child,
.d2-table td:last-child {
  width: 11%;
  padding-right: 22px;
}

.d2-table tbody tr:hover {
  background: #fafcff;
}

.d2-table tbody tr.is-expanded {
  background: #f8fbff;
}

.d2-table .is-number {
  text-align: right;
}

.d2-table .is-number strong {
  display: block;
  color: var(--d2-ink);
  font-size: 14px;
  font-weight: 800;
}

.d2-table .is-number span,
.d2-table .is-number small {
  display: block;
  margin-top: 3px;
  color: var(--d2-muted);
  font-size: 12px;
  line-height: 1.4;
}

.d2-dataset {
  display: flex;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  align-items: flex-start;
  gap: 10px;
  overflow: hidden;
}

.d2-dataset > div {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.d2-dataset-mark {
  width: 8px;
  height: 8px;
  flex: none;
  margin-top: 4px;
  border: 2px solid #c8def7;
  border-radius: 50%;
  background: var(--d2-blue);
}

.d2-dataset strong,
.d2-dataset p {
  display: block;
  margin: 0;
}

.d2-dataset strong {
  color: #263348;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.4;
}

.d2-dataset p {
  width: 100%;
  max-width: 100%;
  margin-top: 4px;
  overflow: hidden;
  color: #7f8b9b;
  font-size: 12px;
  line-height: 1.45;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.d2-chip-stack,
.d2-category-list,
.d2-data-type-list {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 6px;
}

.d2-chip-stack {
  flex-direction: column;
  align-items: flex-start;
}

.d2-model-chip {
  display: inline-flex;
  min-height: 24px;
  max-width: 100%;
  box-sizing: border-box;
  align-items: center;
  border: 1px solid #d5e1ee;
  border-radius: 8px;
  background: #f4f8fd;
  padding: 0 8px;
  color: #2f5f96;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
}

.d2-model-chip-alsemi {
  border-color: #b8d9cd;
  background: var(--d2-green-soft);
  color: var(--d2-green);
}

.d2-model-chip-kisti,
.d2-model-chip-knowledge {
  border-color: #c7d7ee;
  background: var(--d2-blue-soft);
  color: var(--d2-blue);
}

.d2-model-chip-virtual {
  border-color: #d6caea;
  background: #f3eefb;
  color: #6d5592;
}

.d2-model-chip-anomaly,
.d2-model-chip-process {
  border-color: #ebd3a8;
  background: var(--d2-amber-soft);
  color: var(--d2-amber);
}

.d2-category-list {
  flex-direction: column;
}

.d2-category-list article {
  min-width: 0;
  border-left: 3px solid #c9dff6;
  padding-left: 9px;
}

.d2-category-list strong,
.d2-category-list small {
  display: block;
  min-width: 0;
  margin: 0;
}

.d2-category-list strong {
  color: #243246;
  font-size: 12px;
  font-weight: 800;
}

.d2-category-list small {
  margin-top: 2px;
  overflow: hidden;
  color: #7f8b9b;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.d2-data-type-list span {
  display: inline-flex;
  max-width: 100%;
  min-height: 24px;
  align-items: center;
  border-radius: 8px;
  background: #f2f5f8;
  padding: 0 8px;
  color: #526174;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.3;
}

.d2-detail-button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid #bdd3ea;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 10px;
  color: var(--d2-blue);
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.d2-detail-button:hover,
.d2-detail-button:focus-visible {
  outline: 0;
  background: #edf5ff;
}

.d2-detail-row:hover {
  background: #ffffff;
}

.d2-detail-row td {
  padding: 0 22px 22px;
  background: #ffffff;
}

.d2-model-detail {
  border: 1px solid #cfdeef;
  border-radius: 8px;
  background: #fbfdff;
  padding: 16px;
}

.d2-detail-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 16px;
}

.d2-detail-metrics article {
  min-width: 0;
  border: 1px solid var(--d2-line-soft);
  border-radius: 8px;
  background: #ffffff;
  padding: 12px;
}

.d2-detail-metrics span,
.d2-detail-metrics strong {
  display: block;
  margin: 0;
}

.d2-detail-metrics span {
  color: #7a8799;
  font-size: 12px;
  font-weight: 700;
}

.d2-detail-metrics strong {
  margin-top: 5px;
  color: var(--d2-ink);
  font-size: 15px;
  font-weight: 800;
}

.d2-detail-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 0.85fr);
  gap: 14px;
}

.d2-detail-panel {
  min-width: 0;
  border: 1px solid var(--d2-line-soft);
  border-radius: 8px;
  background: #ffffff;
  padding: 14px;
}

.d2-detail-panel h3 {
  margin: 0 0 12px;
  color: #263348;
  font-size: 14px;
  font-weight: 800;
}

.d2-detail-groups,
.d2-doc-list {
  display: grid;
  gap: 10px;
}

.d2-detail-groups article,
.d2-doc-list article {
  min-width: 0;
  border: 1px solid #edf1f6;
  border-radius: 8px;
  background: #fcfdff;
  padding: 12px;
}

.d2-detail-groups header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.d2-detail-groups header strong,
.d2-detail-groups header span {
  margin: 0;
}

.d2-detail-groups header strong {
  color: #263348;
  font-size: 13px;
  font-weight: 800;
}

.d2-detail-groups header span {
  flex: none;
  border-radius: 8px;
  background: #f2f5f8;
  padding: 3px 7px;
  color: #59677a;
  font-size: 12px;
  font-weight: 700;
}

.d2-detail-groups p,
.d2-detail-note p,
.d2-doc-list p {
  margin: 7px 0 0;
  color: var(--d2-text);
  font-size: 12px;
  line-height: 1.55;
}

.d2-detail-groups dl {
  display: grid;
  gap: 6px;
  margin: 10px 0 0;
}

.d2-detail-groups dl > div {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  gap: 8px;
}

.d2-detail-groups dt,
.d2-detail-groups dd {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
}

.d2-detail-groups dt {
  color: #8290a2;
  font-weight: 800;
}

.d2-detail-groups dd {
  min-width: 0;
  overflow-wrap: anywhere;
  color: #445166;
}

.d2-doc-list article {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: start;
  gap: 10px;
}

.d2-doc-list strong {
  display: block;
  color: #263348;
  font-size: 13px;
  font-weight: 800;
}

.d2-doc-list span,
.d2-doc-list b {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  border-radius: 8px;
  padding: 0 8px;
  font-size: 12px;
  white-space: nowrap;
}

.d2-doc-list span {
  background: #f2f5f8;
  color: #59677a;
  font-weight: 700;
}

.d2-doc-list b {
  background: var(--d2-green-soft);
  color: var(--d2-green);
  font-weight: 800;
}

.d2-detail-note {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  border: 1px solid #d8e6f6;
  border-radius: 8px;
  background: #f3f8ff;
  padding: 10px 12px;
  color: var(--d2-blue);
}

.d2-detail-note i {
  margin-top: 2px;
  font-size: 12px;
}

.d2-empty {
  display: grid;
  justify-items: center;
  gap: 8px;
  border: 1px solid var(--d2-line);
  border-radius: 0 0 8px 8px;
  background: #ffffff;
  padding: 42px 18px;
  text-align: center;
}

.d2-empty > i {
  color: #aab6c5;
  font-size: 26px;
}

.d2-empty strong,
.d2-empty p {
  margin: 0;
}

.d2-empty strong {
  color: var(--d2-ink);
  font-size: 14px;
}

.d2-empty p {
  color: var(--d2-muted);
  font-size: 12px;
}

.d2-empty button {
  min-height: 34px;
  border: 1px solid #cddbeb;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 12px;
  color: var(--d2-blue);
  font-size: 12px;
  font-weight: 800;
}

.d2-footer {
  display: flex;
  min-height: 74px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-top: 1px solid var(--d2-line-soft);
  background: #f8fafc;
  padding-inline: max(24px, (100% - 1200px) / 2 + 24px);
  color: #7e8a9b;
  font-size: 12px;
}

.d2-footer-brand {
  color: #263348;
  font-weight: 800;
}

@media (max-width: 1280px) {
  .d2-quick-menu {
    display: none;
  }
}
@media (max-width: 1080px) {
  .d2-metrics {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .d2-model-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .d2-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .d2-search {
    width: 100%;
    min-width: 0;
  }
}
@media (max-width: 760px) {
  .d2-notice {
    grid-template-columns: auto minmax(0, 1fr);
    margin: 12px;
  }
  .d2-notice button {
    grid-column: 1/-1;
    justify-content: center;
  }
  .d2-hero {
    min-height: 340px;
    padding: 38px 18px;
  }
  .d2-hero h1 {
    font-size: 29px;
  }
  .d2-hero-copy > p {
    font-size: 14px;
  }
  .d2-ai-search {
    min-height: auto;
    flex-wrap: wrap;
    padding: 10px;
  }
  .d2-ai-search input {
    flex-basis: calc(100% - 32px);
  }
  .d2-ai-search button {
    width: 100%;
  }
  .d2-metrics,
  .d2-model-summary {
    grid-template-columns: 1fr;
  }
  .d2-metrics {
    padding: 24px 16px;
  }
  .d2-catalog {
    padding: 28px 16px 36px;
  }
  .d2-section-header h2 {
    font-size: 23px;
  }
  .d2-detail-metrics,
  .d2-detail-grid {
    grid-template-columns: 1fr;
  }
  .d2-doc-list article {
    grid-template-columns: minmax(0, 1fr);
  }
  .d2-footer {
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    padding: 18px 16px;
  }
}
:host-context(html[data-theme=dark]) .d2-shell {
  --d2-ink: #edf3fa;
  --d2-text: #b0bdcc;
  --d2-muted: #8997aa;
  --d2-line: #2b394b;
  --d2-line-soft: #263445;
  --d2-canvas: #0b1421;
  --d2-surface: #121e2d;
  background: var(--d2-surface);
}

:host-context(html[data-theme=dark]) .d2-metrics,
:host-context(html[data-theme=dark]) .d2-catalog,
:host-context(html[data-theme=dark]) .d2-footer {
  background: #0d1724;
}

:host-context(html[data-theme=dark]) .d2-metrics article,
:host-context(html[data-theme=dark]) .d2-model-summary article,
:host-context(html[data-theme=dark]) .d2-toolbar,
:host-context(html[data-theme=dark]) .d2-table-wrap,
:host-context(html[data-theme=dark]) .d2-table th,
:host-context(html[data-theme=dark]) .d2-detail-row td,
:host-context(html[data-theme=dark]) .d2-model-detail,
:host-context(html[data-theme=dark]) .d2-detail-panel,
:host-context(html[data-theme=dark]) .d2-detail-metrics article,
:host-context(html[data-theme=dark]) .d2-detail-groups article,
:host-context(html[data-theme=dark]) .d2-doc-list article,
:host-context(html[data-theme=dark]) .d2-empty,
:host-context(html[data-theme=dark]) .d2-search,
:host-context(html[data-theme=dark]) .d2-detail-button {
  background: var(--d2-surface);
}

:host-context(html[data-theme=dark]) .d2-table tbody tr:hover,
:host-context(html[data-theme=dark]) .d2-table tbody tr.is-expanded {
  background: #172538;
}

:host-context(html[data-theme=dark]) .d2-dataset strong,
:host-context(html[data-theme=dark]) .d2-category-list strong,
:host-context(html[data-theme=dark]) .d2-detail-panel h3,
:host-context(html[data-theme=dark]) .d2-detail-metrics strong,
:host-context(html[data-theme=dark]) .d2-detail-groups header strong,
:host-context(html[data-theme=dark]) .d2-doc-list strong,
:host-context(html[data-theme=dark]) .d2-footer-brand {
  color: var(--d2-ink);
}

:host-context(html[data-theme=dark]) .d2-data-type-list span,
:host-context(html[data-theme=dark]) .d2-detail-groups header span,
:host-context(html[data-theme=dark]) .d2-doc-list span {
  background: #1e2c3d;
  color: #b7c4d4;
}

:host-context(html[data-theme=dark]) .d2-quick-menu {
  border-color: #263445;
  background: rgba(18, 30, 45, 0.97);
}

:host-context(html[data-theme=dark]) .d2-quick-menu button {
  border-bottom-color: #25364a;
  color: #aebdce;
}

:host-context(html[data-theme=dark]) .d2-quick-menu-icon {
  background: #25364a;
  color: #aebfd2;
}`],
})
export class PageDashboard2Component implements OnInit {
    public overviewError: string = '';
    public usingFallback: boolean = false;
    public loadedAt: string = '-';

    public summary: any = {};
    public dataContext: any = {};
    public datasets: any[] = [];
    public modelDatasets: any[] = [];

    public modelQuery: string = '';
    public modelFilter: string = 'all';
    public expandedModelId: string = '';
    public agentQuestion: string = '';

    public modelFilters: any[] = [
        { id: 'all', label: '전체' },
        { id: 'alsemi', label: '알세미' },
        { id: 'kisti', label: 'KISTI' },
        { id: 'virtual', label: '가상계측' },
        { id: 'anomaly', label: '이상탐지' },
    ];

    constructor(@Inject( Service) public service: Service) {
        this.applyOverview(this.fallbackOverview());
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.overviewError = '';
        this.usingFallback = false;
        await this.service.render();

        try {
            const response: any = await wiz.call('overview');
            if (response?.code !== 200 || !response?.data) {
                throw new Error(response?.message || `응답 코드 ${response?.code || '없음'}`);
            }
            this.applyOverview(response.data);
        } catch (error: any) {
            this.applyOverview(this.fallbackOverview());
            this.usingFallback = true;
            const detail = typeof error?.message === 'string' && error.message !== '[object Object]'
                ? ` (${error.message})`
                : '';
            this.overviewError = `최신 집계를 불러오지 못해 내장 모델별 샘플 카탈로그를 표시합니다${detail}.`;
        } finally {
            this.loadedAt = this.formatDateTime(new Date());
            await this.service.render();
        }
    }

    private applyOverview(data: any) {
        const fallback = this.fallbackOverview();
        this.summary = data.summary || fallback.summary;
        this.dataContext = data.dataContext || fallback.dataContext;
        this.datasets = Array.isArray(data.datasets) ? data.datasets : fallback.datasets;
        this.modelDatasets = Array.isArray(data.modelDatasets) && data.modelDatasets.length
            ? data.modelDatasets
            : fallback.modelDatasets;

        const visible = this.filteredModelDatasets();
        if (!visible.some((item: any) => item.id === this.expandedModelId)) {
            this.expandedModelId = visible[0]?.id || '';
        }
    }

    private fallbackOverview() {
        const modelDatasets = this.fallbackModelDatasets();
        return {
            summary: {
                totalDatasets: 8,
                totalRecords: 176,
                readyDatasets: 8,
                dataTypeCount: 5,
                capabilityCount: 5,
                modelCount: 2,
                modelDatasetCount: modelDatasets.length,
                alsemiModelCount: 4,
                kistiModelCount: 2,
                virtualModelCount: 1,
                anomalyModelCount: 1,
                modelReferenceChunks: this.totalModelChunks(modelDatasets),
                modelReferenceRecords: this.totalModelRecords(modelDatasets),
                modelReferenceDocuments: this.totalModelDocuments(modelDatasets),
                dataCategoryCount: this.uniqueCategoryCount(modelDatasets),
                usableTrainingRows: 28,
                referenceChunks: 3,
                connectedSourceCount: 2,
            },
            dataContext: {
                modeLabel: 'AI Agent 샘플',
                basisTime: '2026-05-18',
                freshnessLabel: '정적 샘플',
                source: 'Semiconductor Dummy Dataset · Model Dataset Adapter',
            },
            datasets: [],
            modelDatasets,
        };
    }

    private fallbackModelDatasets() {
        return [
            {
                id: 'alsemi-etch-endpoint',
                provider: 'alsemi',
                providerLabel: '알세미',
                modelFamily: 'process',
                modelType: '식각 공정 모델',
                name: '알세미 식각 Endpoint 예측',
                purpose: '식각 종료점과 RF/압력 편차를 함께 판단해 식각 품질 위험을 예측',
                recordCount: 34,
                chunkCount: 18,
                documentCount: 3,
                featureCount: 8,
                updatedAt: '2026-05-18',
                trainingNote: '식각 공정 조건, 센서 구간, 계측 결과와 endpoint 관련 문서 청크를 함께 학습 입력으로 사용합니다.',
                tags: ['alsemi', 'etch'],
                dataGroups: [
                    this.group('식각', '공정 실행 이력·센서 시계열·계측 결과', 24, ['공정 실행 이력', '센서 시계열', '계측·품질 결과'], ['pressure', 'rf_power', 'endpoint', 'thickness'], '식각 recipe와 장비 신호를 종료점 예측 기준으로 묶었습니다.'),
                    this.group('계측', '두께·CD 품질 데이터', 10, ['계측·품질 결과'], ['thickness', 'CD', 'uniformity', 'defect_density'], '식각 이후 품질 편차를 모델 출력 검증 기준으로 사용합니다.'),
                ],
                documents: [
                    this.document('식각 endpoint 기준서', 'Recipe 문서', 7, 'endpoint window, RF power, chamber pressure'),
                    this.document('Plasma etch 공정 논문', '논문 청크', 6, 'CF4/O2 plasma, etch rate, selectivity'),
                    this.document('식각 이상 조치 이력', '운영 메모', 5, 'alarm, lot hold, RCA 후보'),
                ],
            },
            {
                id: 'alsemi-deposition-quality',
                provider: 'alsemi',
                providerLabel: '알세미',
                modelFamily: 'process',
                modelType: '증착 품질 모델',
                name: '알세미 증착 막질 예측',
                purpose: 'ALD/CVD 조건과 계측 결과로 두께, 균일도, particle 위험을 추정',
                recordCount: 32,
                chunkCount: 16,
                documentCount: 3,
                featureCount: 9,
                updatedAt: '2026-05-18',
                trainingNote: '증착 recipe 조건, 챔버 센서와 막질 계측 지표를 같은 학습 단위로 정렬했습니다.',
                tags: ['alsemi', 'deposition', 'virtual'],
                dataGroups: [
                    this.group('증착', '공정 조건·센서 시계열', 19, ['공정 실행 이력', '센서 시계열', 'Recipe 지식'], ['temperature', 'pressure', 'precursor_flow', 'particle'], 'ALD/CVD recipe와 장비 센서를 막질 예측 입력으로 사용합니다.'),
                    this.group('계측', '막 두께·균일도 결과', 13, ['계측·품질 결과'], ['thickness', 'uniformity', 'film_stress'], '증착 이후 측정된 막질 지표를 학습 라벨과 검증 기준으로 사용합니다.'),
                ],
                documents: [
                    this.document('ALD/CVD recipe 사양', 'Recipe 문서', 6, 'pulse, temperature, pressure, precursor'),
                    this.document('박막 증착 품질 논문', '논문 청크', 6, 'film thickness, uniformity, stress'),
                    this.document('Particle alarm 조치 문서', '운영 메모', 4, 'particle spike, chamber clean'),
                ],
            },
            {
                id: 'alsemi-cmp-defect',
                provider: 'alsemi',
                providerLabel: '알세미',
                modelFamily: 'process',
                modelType: 'CMP 결함 모델',
                name: '알세미 CMP 결함 원인 분석',
                purpose: 'CMP 조건과 후속 계측 편차를 연결해 edge defect와 균일도 저하 원인을 분류',
                recordCount: 23,
                chunkCount: 13,
                documentCount: 3,
                featureCount: 7,
                updatedAt: '2026-05-18',
                trainingNote: 'CMP 공정 조건, pad/slurry 센서, 결함 계측과 조치 문서를 결함 원인 후보 학습에 사용합니다.',
                tags: ['alsemi', 'cmp', 'anomaly'],
                dataGroups: [
                    this.group('CMP', '공정 실행 이력·센서 시계열', 15, ['공정 실행 이력', '센서 시계열'], ['down_force', 'slurry_flow', 'pad_temp', 'time'], 'CMP recipe 조건과 소모재 관련 센서를 결함 원인 입력으로 사용합니다.'),
                    this.group('계측', '결함·균일도 품질 데이터', 8, ['계측·품질 결과'], ['defect_density', 'uniformity', 'CD'], 'CMP 이후 결함 밀도와 균일도 편차를 라벨로 사용합니다.'),
                ],
                documents: [
                    this.document('CMP pad/slurry 기준서', '공정 문서', 5, 'pad wear, slurry flow, down force'),
                    this.document('CMP 결함 분석 리포트', '분석 문서', 4, 'edge defect, uniformity drift'),
                    this.document('Lot hold 조치 이력', '운영 메모', 4, 'hold reason, corrective action'),
                ],
            },
            {
                id: 'alsemi-implant-uniformity',
                provider: 'alsemi',
                providerLabel: '알세미',
                modelFamily: 'process',
                modelType: '이온 주입 모델',
                name: '알세미 이온 주입 균일도 예측',
                purpose: 'dose, beam, tilt 조건으로 이온 주입 균일도와 후속 저항 편차를 예측',
                recordCount: 18,
                chunkCount: 11,
                documentCount: 2,
                featureCount: 6,
                updatedAt: '2026-05-18',
                trainingNote: '이온 주입 공정 조건과 anneal/diffusion 후 계측 데이터를 연결해 균일도 학습 기준으로 사용합니다.',
                tags: ['alsemi', 'implant'],
                dataGroups: [
                    this.group('이온 주입', '공정 조건·장비 센서', 11, ['공정 실행 이력', '센서 시계열', 'Recipe 지식'], ['beam_current', 'dose_rate', 'wafer_tilt', 'energy'], 'Implant recipe와 장비 beam 신호를 주입 균일도 입력으로 사용합니다.'),
                    this.group('열처리·확산', '후속 계측 데이터', 7, ['계측·품질 결과'], ['sheet_resistance', 'junction_depth', 'dose_uniformity'], '주입 후 열처리와 확산 결과를 검증 지표로 사용합니다.'),
                ],
                documents: [
                    this.document('이온 주입 recipe 기준', 'Recipe 문서', 6, 'energy, dose, tilt, beam current'),
                    this.document('Dose 균일도 계측 메모', '계측 문서', 5, 'dose uniformity, sheet resistance'),
                ],
            },
            {
                id: 'kisti-process-rag',
                provider: 'kisti',
                providerLabel: 'KISTI',
                modelFamily: 'knowledge',
                modelType: '공정 지식 모델',
                name: 'KISTI 공정 지식 검색·추론',
                purpose: '논문, recipe, 계측 문서를 검색해 공정 조건 질의의 근거 문맥을 구성',
                recordCount: 41,
                chunkCount: 24,
                documentCount: 4,
                featureCount: 10,
                updatedAt: '2026-05-18',
                trainingNote: '공정별 문서 청크와 구조화 샘플을 함께 참조해 답변 근거와 추론 힌트를 구성합니다.',
                tags: ['kisti', 'rag', 'etch', 'deposition'],
                dataGroups: [
                    this.group('식각', '논문 청크·공정 이력', 15, ['논문/문서 RAG', '공정 실행 이력'], ['etch_rate', 'plasma', 'pressure', 'power'], '식각 논문과 recipe 실행 이력을 검색 근거로 사용합니다.'),
                    this.group('증착', '논문 청크·계측 결과', 14, ['논문/문서 RAG', '계측·품질 결과'], ['film_thickness', 'uniformity', 'stress'], '박막 증착 논문과 계측 결과를 답변 근거로 사용합니다.'),
                    this.group('계측', '품질 문서·측정 데이터', 12, ['계측·품질 결과', '문서 RAG'], ['CD', 'overlay', 'defect_density'], '계측 지표와 품질 문서를 모델 참조 문맥으로 구성합니다.'),
                ],
                documents: [
                    this.document('식각 논문 선별 청크', '논문 청크', 8, 'etching characteristics, plasma chemistry'),
                    this.document('증착 논문 선별 청크', '논문 청크', 7, 'thin film, ALD, CVD'),
                    this.document('계측 품질 가이드', '품질 문서', 5, 'CD, overlay, defect'),
                    this.document('Recipe 파라미터 사전', '지식 문서', 4, 'target, parameter, control'),
                ],
            },
            {
                id: 'kisti-equipment-inference',
                provider: 'kisti',
                providerLabel: 'KISTI',
                modelFamily: 'knowledge',
                modelType: '장비 상태 추론 모델',
                name: 'KISTI 장비 상태 추론',
                purpose: '장비 마스터, 센서, 이벤트를 연결해 장비 상태와 점검 필요성을 추론',
                recordCount: 36,
                chunkCount: 19,
                documentCount: 3,
                featureCount: 8,
                updatedAt: '2026-05-18',
                trainingNote: '장비 상태, 센서 추세와 이벤트/알람 로그를 연결해 Agent의 점검 권고 근거로 사용합니다.',
                tags: ['kisti', 'equipment', 'anomaly'],
                dataGroups: [
                    this.group('장비 상태', '장비 마스터·상태 로그', 12, ['장비 마스터', '이벤트·알람 로그'], ['equipment', 'status', 'utilization', 'pm_due'], '장비별 상태와 PM 정보를 추론 입력으로 사용합니다.'),
                    this.group('센서', '센서 시계열', 16, ['센서 시계열'], ['trend', 'baseline', 'contribution'], '주요 센서 trend와 baseline 편차를 상태 판단 근거로 사용합니다.'),
                    this.group('이벤트', '알람·정비 이벤트', 8, ['이벤트·알람 로그'], ['severity', 'message', 'time'], '알람과 정비 이벤트를 원인 후보 문맥으로 사용합니다.'),
                ],
                documents: [
                    this.document('장비 PM 기준 문서', '운영 문서', 7, 'PM due, utilization, health'),
                    this.document('알람 코드 설명서', '운영 문서', 6, 'severity, alarm message, action'),
                    this.document('센서 baseline 정의서', '데이터 사전', 6, 'baseline, trend, contribution'),
                ],
            },
            {
                id: 'virtual-metrology',
                provider: 'core',
                providerLabel: '가상계측',
                modelFamily: 'virtual',
                modelType: 'Virtual Metrology',
                name: '웨이퍼 두께 가상계측',
                purpose: '공정 직후 계측 전 두께와 균일도를 예측해 빠른 품질 판단을 지원',
                recordCount: 42,
                chunkCount: 21,
                documentCount: 3,
                featureCount: 7,
                updatedAt: '2026-05-18',
                trainingNote: '두께가 존재하는 공정 실행 이력과 계측 결과를 짝지어 가상계측 학습 표본으로 사용합니다.',
                tags: ['virtual', 'vm-thickness', 'deposition', 'etch'],
                dataGroups: [
                    this.group('식각·증착', '공정 실행 이력', 26, ['공정 실행 이력', 'Recipe 지식'], ['temperature', 'pressure', 'power', 'time', 'recipe'], '식각과 증착 조건을 두께 예측 입력으로 사용합니다.'),
                    this.group('계측', '두께·균일도 결과', 16, ['계측·품질 결과'], ['thickness', 'uniformity', 'sigma'], '실측 두께와 균일도를 모델 라벨과 검증 기준으로 사용합니다.'),
                ],
                documents: [
                    this.document('Virtual Metrology 학습 사양', '모델 문서', 8, 'feature schema, label mapping'),
                    this.document('두께 계측 기준서', '계측 문서', 7, 'thickness, uniformity, sigma'),
                    this.document('Recipe-계측 매핑표', '데이터 사전', 6, 'recipe, lot, wafer, metric'),
                ],
            },
            {
                id: 'anomaly-detection',
                provider: 'core',
                providerLabel: '이상탐지',
                modelFamily: 'anomaly',
                modelType: 'Anomaly Detection',
                name: '공정 이상탐지',
                purpose: '압력, 전력, 시간, 이벤트 신호로 공정 이상과 RCA 후보를 탐지',
                recordCount: 58,
                chunkCount: 27,
                documentCount: 4,
                featureCount: 9,
                updatedAt: '2026-05-18',
                trainingNote: '공정 실행 이력, 센서 baseline, 이벤트/알람과 품질 편차 문서를 이상탐지 근거로 사용합니다.',
                tags: ['anomaly', 'etch', 'cmp', 'deposition'],
                dataGroups: [
                    this.group('식각·CMP·증착', '공정 실행 이력', 25, ['공정 실행 이력'], ['pressure', 'power', 'time', 'status'], 'watch/hot 상태가 포함된 공정 실행 표본을 이상탐지 입력으로 사용합니다.'),
                    this.group('센서', '센서 시계열', 18, ['센서 시계열'], ['baseline', 'trend', 'min', 'avg', 'max'], 'baseline 대비 편차와 spike trend를 이상 신호로 사용합니다.'),
                    this.group('이벤트·계측', '알람 로그·품질 결과', 15, ['이벤트·알람 로그', '계측·품질 결과'], ['severity', 'defect_density', 'uniformity'], '알람과 계측 편차를 RCA 후보 검증에 사용합니다.'),
                ],
                documents: [
                    this.document('이상탐지 feature 정의서', '모델 문서', 8, 'pressure, power, time, status'),
                    this.document('센서 baseline 산정 기준', '데이터 사전', 7, 'baseline, trend, contribution'),
                    this.document('RCA 조치 이력 청크', '운영 메모', 7, 'alarm, root cause, action'),
                    this.document('품질 이상 판단 기준', '품질 문서', 5, 'defect, uniformity, Cpk'),
                ],
            },
        ];
    }

    private group(category: string, dataType: string, recordCount: number, sources: string[], fields: string[], description: string) {
        return {
            category,
            dataType,
            recordCount,
            sourceNames: sources,
            sourceSummary: sources.join(' · '),
            fields,
            description,
        };
    }

    private document(title: string, documentType: string, chunkCount: number, scope: string) {
        return { title, documentType, chunkCount, scope };
    }

    public summaryCards() {
        const summary = this.currentModelSummary();
        return [
            { label: 'AI 모델', value: summary.modelCount, unit: '개', detail: 'AI Agent가 참조하는 학습·추론 모델 전체' },
            { label: '학습 청크', value: summary.chunkCount, unit: '개', detail: '구조화 데이터와 문서 청크 합산' },
            { label: '데이터 카테고리', value: summary.categoryCount, unit: '종', detail: '식각, 증착, CMP, 계측 등 공정 묶음' },
            { label: '학습 데이터', value: summary.recordCount, unit: '건', detail: '모델별 학습·참조 입력 레코드 합산' },
            { label: '참조 문서', value: summary.documentCount, unit: '개', detail: '모델 응답 근거로 연결된 문서 묶음' },
        ];
    }

    public providerSummaryCards() {
        const summary = this.currentModelSummary();
        return [
            { label: '공정 특화 모델', count: summary.alsemiCount, detail: '알세미 식각·증착·CMP·이온 주입', icon: 'fa-industry' },
            { label: '지식 추론 모델', count: summary.kistiCount, detail: 'KISTI 공정 지식·장비 상태 추론', icon: 'fa-building-columns' },
            { label: '가상계측', count: summary.virtualCount, detail: '두께·균일도 예측', icon: 'fa-chart-line' },
            { label: '이상탐지', count: summary.anomalyCount, detail: '센서·이벤트 기반 탐지', icon: 'fa-triangle-exclamation' },
        ];
    }

    private currentModelSummary() {
        const rows = this.modelDatasets || [];
        return {
            modelCount: this.summary.modelDatasetCount || rows.length,
            alsemiCount: this.summary.alsemiModelCount || this.modelFilterCount('alsemi'),
            kistiCount: this.summary.kistiModelCount || this.modelFilterCount('kisti'),
            virtualCount: this.summary.virtualModelCount || this.modelFilterCount('virtual'),
            anomalyCount: this.summary.anomalyModelCount || this.modelFilterCount('anomaly'),
            chunkCount: this.summary.modelReferenceChunks || this.totalModelChunks(rows),
            categoryCount: this.summary.dataCategoryCount || this.uniqueCategoryCount(rows),
            recordCount: this.summary.modelReferenceRecords || this.totalModelRecords(rows),
            documentCount: this.summary.modelReferenceDocuments || this.totalModelDocuments(rows),
        };
    }

    private totalModelChunks(rows: any[]) {
        return (rows || []).reduce((total: number, item: any) => total + Number(item.chunkCount || 0), 0);
    }

    private totalModelRecords(rows: any[]) {
        return (rows || []).reduce((total: number, item: any) => total + Number(item.recordCount || 0), 0);
    }

    private totalModelDocuments(rows: any[]) {
        return (rows || []).reduce((total: number, item: any) => {
            const documentCount = item.documentCount ?? item.documents?.length ?? 0;
            return total + Number(documentCount || 0);
        }, 0);
    }

    private uniqueCategoryCount(rows: any[]) {
        const categories = new Set<string>();
        for (const item of rows || []) {
            for (const group of item.dataGroups || []) {
                if (group?.category) categories.add(String(group.category));
            }
        }
        return categories.size;
    }

    public filteredModelDatasets() {
        const query = String(this.modelQuery || '').trim().toLowerCase();
        return (this.modelDatasets || []).filter((item: any) => {
            const filterMatches = this.modelMatchesFilter(item, this.modelFilter);
            if (!filterMatches) return false;
            if (!query) return true;
            const groupText = (item.dataGroups || []).map((group: any) => [
                group.category,
                group.dataType,
                group.sourceSummary,
                ...(group.fields || []),
            ].join(' '));
            const documentText = (item.documents || []).map((doc: any) => [
                doc.title,
                doc.documentType,
                doc.scope,
            ].join(' '));
            const haystack = [
                item.name,
                item.providerLabel,
                item.modelType,
                item.purpose,
                item.trainingNote,
                ...(item.tags || []),
                ...groupText,
                ...documentText,
            ].join(' ').toLowerCase();
            return haystack.includes(query);
        });
    }

    private modelMatchesFilter(item: any, filter: string) {
        if (filter === 'all') return true;
        if (filter === item.provider || filter === item.modelFamily) return true;
        return (item.tags || []).includes(filter);
    }

    public modelFilterCount(filter: string) {
        return (this.modelDatasets || []).filter((item: any) => this.modelMatchesFilter(item, filter)).length;
    }

    public setModelFilter(filter: string) {
        this.modelFilter = filter;
        this.ensureExpandedModelVisible();
        this.service.render();
    }

    public clearModelQuery() {
        this.modelQuery = '';
        this.ensureExpandedModelVisible();
        this.service.render();
    }

    public clearModelFilters() {
        this.modelQuery = '';
        this.modelFilter = 'all';
        this.ensureExpandedModelVisible();
        this.service.render();
    }

    private ensureExpandedModelVisible() {
        const visible = this.filteredModelDatasets();
        if (!visible.some((item: any) => item.id === this.expandedModelId)) {
            this.expandedModelId = visible[0]?.id || '';
        }
    }

    public modelFilterClass(filter: string) {
        return this.modelFilter === filter ? 'd2-filter is-active' : 'd2-filter';
    }

    public toggleModelDetail(id: string) {
        this.expandedModelId = this.expandedModelId === id ? '' : id;
        this.service.render();
    }

    public isModelExpanded(id: string) {
        return this.expandedModelId === id;
    }

    public modelChipClass(kind: string) {
        return `d2-model-chip d2-model-chip-${kind || 'default'}`;
    }

    public formatList(values: any[]) {
        const list = Array.isArray(values) ? values.filter(Boolean) : [];
        return list.length ? list.join(', ') : '-';
    }

    public formatNumber(value: any) {
        const parsed = Number(value || 0);
        return Number.isFinite(parsed) ? parsed.toLocaleString('ko-KR') : String(value || '-');
    }

    public formatDateTime(value: Date) {
        const pad = (part: number) => String(part).padStart(2, '0');
        return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())} ${pad(value.getHours())}:${pad(value.getMinutes())}`;
    }

    public openDataHub() {
        this.service.href('/agent/history');
    }

    public openAgent() {
        this.service.href('/agent/chat');
    }

    public askNanoFab() {
        const question = String(this.agentQuestion || '').trim().slice(0, 2000);
        if (!question) return;
        try {
            sessionStorage.setItem('nanofab.agent.pending-question', question);
        } catch (_error) {
            // 제한된 브라우저 환경에서도 채팅 화면 이동은 유지합니다.
        }
        this.service.href('/agent/chat');
    }

    public focusModelFilter(filter: string) {
        this.setModelFilter(filter);
        this.modelQuery = '';
        this.ensureExpandedModelVisible();
        this.service.render();
        this.scrollToSection('d2-catalog-title');
    }

    public focusModelCategory(category: string) {
        this.modelFilter = 'all';
        this.modelQuery = category;
        this.ensureExpandedModelVisible();
        this.service.render();
        this.scrollToSection('d2-catalog-title');
    }

    public scrollToSection(id: string) {
        if (typeof document === 'undefined') return;
        const target = document.getElementById(id);
        if (!target) return;
        const scrollSurface = document.querySelector('.d2l-main-surface, .nf-main-surface') as HTMLElement | null;
        if (scrollSurface && scrollSurface.contains(target)) {
            const targetTop = target.getBoundingClientRect().top;
            const surfaceTop = scrollSurface.getBoundingClientRect().top;
            scrollSurface.scrollTo({
                top: scrollSurface.scrollTop + targetTop - surfaceTop,
                behavior: 'smooth',
            });
            return;
        }
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    public scrollToTop() {
        if (typeof document === 'undefined') return;
        const scrollSurface = document.querySelector('.d2l-main-surface, .nf-main-surface') as HTMLElement | null;
        if (scrollSurface) {
            scrollSurface.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }
        if (typeof window !== 'undefined') window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

export default PageDashboard2Component;